<template>
  <div class="bt_table_box">
    <div class="bt_rows">
      <div class="bt_title bt_sigo">
        <p>实际项名称</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.Name}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>职权类别</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.AffairTypeName}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>职权编码</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.Code}}</p>
      </div>
    </div>
    <div class="bt_rows" v-if="tableForm.affair.ParentName">
      <div class="bt_title">
        <p>主项名称</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.ParentName}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>单位名称</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.UnitName}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>主办科室</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.ImplementingAgency}}</p>
      </div>
    </div>
    <!-- <div
      class="bt_rows"
      v-if="tableForm.affair.AffairTypeId == 1 || tableForm.affair.AffairTypeId == 4 || tableForm.affair.AffairTypeId == 5 || tableForm.affair.AffairTypeId == 7 || tableForm.affair.AffairTypeId == 8"
    >
      <div class="bt_title">
        <p>受理地点</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.AcceptAddress}}</p>
      </div>
    </div>-->
    <!-- <div
      class="bt_rows"
      v-if="tableForm.affair.AffairTypeId == 1 || tableForm.affair.AffairTypeId == 4 || tableForm.affair.AffairTypeId == 5 || tableForm.affair.AffairTypeId == 7 || tableForm.affair.AffairTypeId == 8"
    >
      <div class="bt_title bt_big_title">
        <p>是否纳入行政服务中心办理</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.IsChannel == 0 ? "否" : "是"}}</p>
      </div>
    </div>-->
    <!-- <div class="bt_rows" v-if="tableForm.affair.AffairTypeId == 1">
      <div class="bt_title bt_big_title">
        <p>审批证件名称及有效期</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.ApprovalName}}</p>
      </div>
    </div>-->
    <div class="bt_rows">
      <div class="bt_title">
        <p>设立依据</p>
      </div>
      <div class="bt_text">
        <div
          class="bt_text_flex"
          v-for="(slyj,slyjIndex) in tableForm.slyjList"
          :key="slyjIndex"
          :class="{'border-bottom': slyjIndex < tableForm.slyjList.length-1}"
        >
          <!-- <p class="bt_text_flexTitle">{{slyjIndex+1}}</p> -->
          <p class="bt_text_flexContent">{{slyjIndex+1}}&nbsp;{{slyj.Content}}</p>
        </div>
      </div>
    </div>

    <!-- <div
      class="bt_rows"
      v-if="tableForm.affair.AffairTypeId == 1  || tableForm.affair.AffairTypeId == 7 || tableForm.affair.AffairTypeId == 8"
    >
      <div class="bt_title" :class="{'bt_big_title': tableForm.affair.IsFeeNorm == 0}">
        <p>收费依据及标准</p>
      </div>
      <div class="bt_text">
        <p class="p_color_red" v-if="tableForm.affair.IsFeeNorm == 0">不收费</p>
        <div
          v-else
          class="bt_text_flex"
          v-for="(fee,feeIndex) in tableForm.feeList"
          :key="feeIndex"
          :class="{'border-bottom': feeIndex < tableForm.feeList.length-1}"
        >
          <p class="bt_text_flexTitle">{{fee.FeeBasis}}</p>
          <p class="bt_text_flexContent">{{fee.FeeNorm}}</p>
        </div>
      </div>
    </div>
    <div class="bt_rows" v-if="tableForm.affair.AffairTypeId == 4">
      <div class="bt_title">
        <p>征收标准及依据</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.CollectionBasis}}</p>
      </div>
    </div>-->

    <div class="bt_rows" style="border: 0px">
      <div class="bt_title bt_big_title bt_sigo">
        <p>各环节责任事项及责任科室</p>
      </div>
    </div>

    <div class="bt_rows" v-for="(duty,dutyIndex) in tableForm.dutyList" :key="dutyIndex">
      <div class="bt_text">
        <div class="bt_text_flex">
          <div class="bt_text_content">
            <p class="bt_text_flexTitle">{{duty.Step}}</p>
            <p class="bt_text_flexContent">{{duty.DutyItem}}</p>
          </div>
          <div class="bt_text_unit">
            <p class="bt_text_flexUnit">{{duty.DutyDepartment}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bt_rows" v-if="tableForm.affair.AffairTypeId == 1">
      <div class="bt_title">
        <p>办理期限</p>
      </div>
      <div class="bt_text">
        <p
          class="p_color_blue"
        >法定期限：{{tableForm.affair.LegalDay}}{{tableForm.affair.LegalDayType | DayTypeFilter}}</p>
        <p
          class="p_color_blue"
        >承若期限：{{tableForm.affair.PromiseDay}}{{tableForm.affair.PromiseDayType | DayTypeFilter}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>监督电话</p>
      </div>
      <div class="bt_text">
        <p class="p_color_blue">{{tableForm.affair.ControlPhone | phoneFilter}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>服务电话</p>
      </div>
      <div class="bt_text">
        <p class="p_color_blue">{{tableForm.affair.ServicePhone | phoneFilter}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>救济途径（复议、诉讼）</p>
      </div>
      <div class="bt_text">
        <p>{{tableForm.affair.Review}}</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title">
        <p>附件下载</p>
      </div>
      <div class="bt_text" v-if="!!tableForm.fileUpload.NewFileName">
        <a
          :href="'http://61.158.166.5:8099/UploadFiles/Affair/'+tableForm.fileUpload.NewFileName"
        >{{ tableForm.fileUpload.FileName }}</a>
      </div>
      <div class="bt_text" v-else>
        <p>无下载信息</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_title bt_big_title" v-show="tableForm.imgUrl">
        <p>办事流程图</p>
      </div>
    </div>
    <div class="bt_rows">
      <div class="bt_text" v-show="tableForm.imgUrl">
        <img :src="'http://61.158.166.5:8099/'+tableForm.imgUrl" preview="0" data-pswp-uid="0" />
      </div>
      <div class="bt_text" v-show="!tableForm.imgUrl">
        <p>无</p>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    tableId: {
      type: Number
    }
  },
  data() {
    return {
      tableForm: {
        affair: {},
        dutyList: [],
        fileUrl: "",
        // imgUrl: "",
        feeList: [],
        slyjList: []
        // fileUpload: {}
      }
    };
  },
  mounted() {
    this.getDetailById();
  },
  methods: {
    getDetailById() {
      this.$axios({
        url: "api/getDetailById/" + this.tableId,
        type: "get"
      })
        .then(res => {
          this.tableForm = res.data;
          this.$previewRefresh();
        })
        .catch(err => {
          console.info(err);
        });
    }
  },
  filters: {
    DayTypeFilter: function(value) {
      if (value == 1) {
        return "个工作日";
      } else if (value == 2) {
        return "日";
      } else if (value == 3) {
        return "个月";
      } else if (value == 4) {
        return "年";
      }
    },
    phoneFilter: function(value) {
      if (value) {
        if (value.trim().indexOf("0373") == 0) {
          return value;
        } else {
          return "0373-" + value;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>